/**
 * Get the display color for a criteria option based on its name
 * @param {string} optionName - The name of the option (e.g., "Platinum", "Gold", "Silver")
 * @returns {string} The hex color code
 */
export const getOptionColor = optionName => {
  const name = optionName?.toLowerCase() || '';
  if (name.includes('3') || name.includes('gold') || name.includes('or')) return '#FFD700'; // Gold
  if (name.includes('2') || name.includes('silver') || name.includes('argent')) return '#C0C0C0'; // Silver
  if (name.includes('1') || name.includes('bronze')) return '#CD7F32'; // Bronze
  return '#999'; // Default gray
};
